// Module
var code = "<meeting-messages-component messages=\"ctrl.messages\" on-update=\"ctrl.onUpdate\" on-add=\"ctrl.onAdd\" on-delete=\"ctrl.onDelete\"></meeting-messages-component>";
// Exports
module.exports = code;